import { css } from '@microsoft/fast-element';

export const InfoIconStyles = css`
    .info-icon-tooltip {
        width: 16px;
        display:inline-block;
        padding-left: 4px;
    }
`;
